import { render, staticRenderFns } from "./stockpile.vue?vue&type=template&id=3c5d151d&scoped=true&"
import script from "./stockpile.vue?vue&type=script&lang=js&"
export * from "./stockpile.vue?vue&type=script&lang=js&"
import style0 from "./stockpile.vue?vue&type=style&index=0&id=3c5d151d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d151d",
  null
  
)

export default component.exports